"use strict";

var _slicedToArray = require("/vercel/path0/node_modules/@babel/runtime/helpers/slicedToArray.js").default;
var _regeneratorRuntime = require("/vercel/path0/node_modules/@babel/runtime/helpers/regeneratorRuntime.js").default;
var _asyncToGenerator = require("/vercel/path0/node_modules/@babel/runtime/helpers/asyncToGenerator.js").default;
var _classCallCheck = require("/vercel/path0/node_modules/@babel/runtime/helpers/classCallCheck.js").default;
var _createClass = require("/vercel/path0/node_modules/@babel/runtime/helpers/createClass.js").default;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AsyncStorage = exports.StorageSDK = void 0;
var async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
var lodash_1 = require("lodash");
var utils_1 = require("./utils");
var utils_2 = require("../base/utils");
var StorageSDK = /*#__PURE__*/function () {
  function StorageSDK() {
    _classCallCheck(this, StorageSDK);
    this.api = async_storage_1.default;
  }
  _createClass(StorageSDK, [{
    key: "getAllKeys",
    value: function () {
      var _getAllKeys = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              return _context.abrupt("return", this.api.getAllKeys());
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getAllKeys() {
        return _getAllKeys.apply(this, arguments);
      }
      return getAllKeys;
    }()
  }, {
    key: "removeItem",
    value: function () {
      var _removeItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(key) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.api.removeItem(key);
            case 2:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function removeItem(_x) {
        return _removeItem.apply(this, arguments);
      }
      return removeItem;
    }()
  }, {
    key: "mergeItem",
    value: function () {
      var _mergeItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(key, value) {
        var stringified;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              stringified = JSON.stringify(value);
              _context3.next = 3;
              return this.api.mergeItem(key, stringified);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function mergeItem(_x2, _x3) {
        return _mergeItem.apply(this, arguments);
      }
      return mergeItem;
    }()
  }, {
    key: "multiRemove",
    value: function () {
      var _multiRemove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(keys) {
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.api.multiRemove(keys);
            case 2:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function multiRemove(_x4) {
        return _multiRemove.apply(this, arguments);
      }
      return multiRemove;
    }()
  }, {
    key: "multiMerge",
    value: function () {
      var _multiMerge = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(keyValuePairs) {
        var stringifiedPairs;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              stringifiedPairs = (0, utils_1.stringifyPairs)(keyValuePairs);
              if (!stringifiedPairs) {
                _context5.next = 4;
                break;
              }
              _context5.next = 4;
              return this.api.multiMerge(stringifiedPairs);
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function multiMerge(_x5) {
        return _multiMerge.apply(this, arguments);
      }
      return multiMerge;
    }()
  }, {
    key: "clear",
    value: function () {
      var _clear = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.api.clear();
            case 2:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function clear() {
        return _clear.apply(this, arguments);
      }
      return clear;
    }()
  }, {
    key: "flushGetRequests",
    value: function flushGetRequests() {
      this.api.flushGetRequests();
    }
  }, {
    key: "safeSet",
    value: function safeSet(key, value, onError) {
      this.setItem(key, value).catch(onError || lodash_1.noop);
    }
  }, {
    key: "safeRemove",
    value: function safeRemove(key, onError) {
      this.api.removeItem(key).catch(onError || lodash_1.noop);
    }
  }, {
    key: "setItem",
    value: function () {
      var _setItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7(key, value) {
        var stringified;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              stringified = JSON.stringify(value);
              _context7.next = 3;
              return this.api.setItem(key, stringified);
            case 3:
            case "end":
              return _context7.stop();
          }
        }, _callee7, this);
      }));
      function setItem(_x6, _x7) {
        return _setItem.apply(this, arguments);
      }
      return setItem;
    }()
  }, {
    key: "getItem",
    value: function () {
      var _getItem = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8(key) {
        var jsonValue;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              _context8.next = 2;
              return this.api.getItem(key);
            case 2:
              jsonValue = _context8.sent;
              return _context8.abrupt("return", (0, utils_2.tryJson)(jsonValue !== null && jsonValue !== void 0 ? jsonValue : ""));
            case 4:
            case "end":
              return _context8.stop();
          }
        }, _callee8, this);
      }));
      function getItem(_x8) {
        return _getItem.apply(this, arguments);
      }
      return getItem;
    }()
  }, {
    key: "multiSet",
    value: function () {
      var _multiSet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee9(keyValuePairs) {
        var stringifiedPairs;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              stringifiedPairs = (0, utils_1.stringifyPairs)(keyValuePairs);
              if (!stringifiedPairs) {
                _context9.next = 4;
                break;
              }
              _context9.next = 4;
              return this.api.multiSet(stringifiedPairs);
            case 4:
            case "end":
              return _context9.stop();
          }
        }, _callee9, this);
      }));
      function multiSet(_x9) {
        return _multiSet.apply(this, arguments);
      }
      return multiSet;
    }()
  }, {
    key: "multiGet",
    value: function () {
      var _multiGet = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee10(keys) {
        var keyJsonValuePairs;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _context10.next = 2;
              return this.api.multiGet(keys);
            case 2:
              keyJsonValuePairs = _context10.sent;
              return _context10.abrupt("return", keyJsonValuePairs.map(function (_ref) {
                var _ref2 = _slicedToArray(_ref, 2),
                  key = _ref2[0],
                  jsonValue = _ref2[1];
                return [key, (0, utils_2.tryJson)(jsonValue !== null && jsonValue !== void 0 ? jsonValue : "")];
              }));
            case 4:
            case "end":
              return _context10.stop();
          }
        }, _callee10, this);
      }));
      function multiGet(_x10) {
        return _multiGet.apply(this, arguments);
      }
      return multiGet;
    }()
  }]);
  return StorageSDK;
}();
exports.StorageSDK = StorageSDK;
exports.AsyncStorage = new StorageSDK();